<template>
  <div id="app">
    <header class="header">
      <div class="main-con">
        <div class="logo">
          <img src="./assets/images/icon_logo.png" alt="" class="icon">
          <h1 class="title">自在生活</h1>
        </div>
        <nav class="nav-bar">
          <router-link class="btn-nav" :to="{name:'home'}">首页</router-link>
          <router-link class="btn-nav" :to="{name:'product'}">平台产品</router-link>
          <router-link class="btn-nav" :to="{name:'service'}">平台服务</router-link>
          <a href="http://open.zizai.thinkinpower.com/#/support" target="_blank" class="btn-nav">平台合作</a>
          <router-link class="btn-nav" :to="{name:'about'}">关于我们</router-link>
          <router-link class="btn-nav" :to="{name:'download'}">下载</router-link>
        </nav>
      </div>
    </header>
    <router-view></router-view>
    <footer class="footer">
      <div class="main-con">
        <div>
          <span>商务合作：biz@thinkinpower.com</span> &nbsp;&nbsp;|&nbsp;&nbsp;
          <span>意见反馈：service@thinkinpower.com</span> &nbsp;&nbsp;|&nbsp;&nbsp;
          <span>联系电话：020-38882777</span> &nbsp;&nbsp;|&nbsp;&nbsp;
          <span>地址：广州市天河区珠江新城华夏路10号富力中心35楼3503室</span>
        </div>
        <div>
          COPYRIGHT &copy; 2017 ThinkinPower,ALL RIGHT RESERVED.<a target="_blank" href="http://www.miitbeian.gov.cn/">粤ICP备16101578号</a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {
      // showLoading: true
      // routerName:this.$route.name
    }
  },
  computed: {

  },
  methods: {
    getUrlParams() {
      var obj = {}
      var name, value;
      var str = location.search; //取得整个地址栏
      var num = str.indexOf("?")
      str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

      var arr = str.split("&"); //各个参数放到数组里
      for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
          name = arr[i].substring(0, num);
          value = arr[i].substr(num + 1);
          obj[name] = value;
        }
      }
      this.$store.dispatch('setUrlParams', obj);
    }
  },
  created() {

  },
  mounted() {
    // var el = document.getElementById('static-loading');
    // el.parentNode.removeChild(el);
  },
  components: {

  }
}
</script>

<style lang="less">
@import './assets/less/base.less';
@import './assets/less/style.less';
.header {
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgb(239, 244, 248);
  border-bottom: 1px solid rgb(204, 205, 207);
  background-image: linear-gradient(180deg, rgb(242, 243, 247), rgb(242, 243, 247) 100%, transparent 0);
  background-size: 100% 3px;
  background-repeat: no-repeat;
  background-position: center bottom;
  width: 100%;
  height: 70px;
  z-index: 10;
  .main-con {
    height: 100%;
  }
  .logo {
    white-space: nowrap;
    height: 100%;
    float: left;
    .icon {
      .bgImg('@{publicBaseUrl}icon_logo.png');
      background: none;
      display: inline-block;
      vertical-align: middle;
      margin-right: 20px;
    }
    .title {
      display: inline-block;
      font-size: 24px;
      color: @c_title;
      line-height: 70px;
      font-style: italic;
      vertical-align: middle;
      margin: 0;
    }
  }
  .nav-bar {
    white-space: nowrap;
    float: right;
    height: 100%;
    cursor: default;
    .btn-nav {
      line-height: 70px;
      cursor: pointer;
      color: @c_title;
      display: inline-block;
      margin-left: 40px;
      cursor: pointer;
      &.router-link-active {
        color: @c_main;
        font-weight: bold;
      }
    }
  }
}

.footer {
  padding: 70px 0;
  .main-con {
    border-top: 1px solid #dadbdf;
    padding: 20px 0;
    font-size: 12px;
    line-height: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// App.vue?d78fc230